<template>
    <div class="structure-block-teaser-cards relative h-fit pb-6 xl:pb-0 max-w-[1408px] mx-auto md:min-h-[432px]">
        <button
            class="swiper-button-prev swiper-pagination-element swiper-custom-button-prev btn border-none btn-primary absolute top-1/2 -left-6 transform -translate-y-1/2 z-40 -mt-8 xl:hidden"
            tabindex="0"
            :aria-label="t('product.slider.prev')"
            @click="prevSlide"
        >
            <MiscIcon name="chevron-left" />
        </button>

        <Swiper
            ref="swiperCarousel"
            class="w-full h-full xl:!overflow-visible xl:!flex xl:justify-center"
            :slides-per-view="1"
            :loop="true"
            :space-between="8"
            :breakpoints="{
                '490': {
                    slidesPerView: 2
                },
                '768': {
                    slidesPerView: 3
                },
                '1280': {
                    loop: false,
                    slidesPerView: 4,
                    spaceBetween: 32
                },
            }"
        >
            <SwiperSlide>
                <component :is="leftComponent" :content="leftSlot" />
            </SwiperSlide>
            <SwiperSlide>
                <component :is="centerLeftComponent" :content="centerLeftSlot" />
            </SwiperSlide>
            <SwiperSlide>
                <component :is="centerRightComponent" :content="centerRightSlot" />
            </SwiperSlide>
            <SwiperSlide>
                <component :is="rightComponent" :content="rightSlot" />
            </SwiperSlide>
        </Swiper>

        <button
            class="swiper-button-next swiper-pagination-element swiper-custom-button-next btn border-none btn-primary absolute top-1/2 -right-6 transform -translate-y-1/2 z-40 -mt-8 xl:hidden"
            tabindex="0"
            :aria-label="t('product.slider.next')"
            @click="nextSlide"
        >
            <MiscIcon name="chevron-right" />
        </button>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'
import type { HblSlot } from '@/utils/types'
import { hblToUpperCamelCase } from '@/utils/helper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'

const props = defineProps<{
    content: HblSlot[]
}>()

const { t } = useI18n()

const swiperCarousel = ref(null)

const leftSlot = computed(() => {
    return props.content.find(item => item.position === 'left')
})

const centerLeftSlot = computed(() => {
    return props.content.find(item => item.position === 'centerLeft')
})

const centerRightSlot = computed(() => {
    return props.content.find(item => item.position === 'centerRight')
})

const rightSlot = computed(() => {
    return props.content.find(item => item.position === 'right')
})

const leftComponent = computed(() => {
    if (!leftSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(leftSlot.value.type)}`
})

const centerLeftComponent = computed(() => {
    if (!centerLeftSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(centerLeftSlot.value.type)}`
})

const centerRightComponent = computed(() => {
    if (!centerRightSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(centerRightSlot.value.type)}`
})

const rightComponent = computed(() => {
    if (!rightSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(rightSlot.value.type)}`
})

function prevSlide () {
    swiperCarousel?.value.$el.swiper.slidePrev()
}

function nextSlide () {
    swiperCarousel?.value.$el.swiper.slideNext()
}
</script>
